import React, { useState } from "react";
import { TextField, Button, Typography, Box } from "@mui/material";
import { useInviteMemberMutation } from "../../services/user";
import { toast } from "react-toastify";

const InvitationOrg = () => {
	const [email, setEmail] = useState("");
	const [sendInvitation, { isLoading }] = useInviteMemberMutation();

	const handleSubmit = async (event) => {
		event.preventDefault();
		try {
			await sendInvitation({ recipentMail: email, type: "org" }).unwrap();
			toast("Invitation sent successfully!");
			setEmail("");
		} catch (err) {
			console.log(err);
			if (err.data) {
				toast(err?.data?.error?.message);
			}
		}
	};

	return (
		<Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
			<Typography variant="h6" gutterBottom>
				Invite Organization
			</Typography>
			<TextField
				label="Email"
				variant="outlined"
				type="email"
				required
				fullWidth
				value={email}
				size="small"
				onChange={(e) => setEmail(e.target.value)}
				sx={{ mb: 2 }}
			/>
			<Button
				type="submit"
				variant="contained"
				sx={{ maxWidth: "300px", marginLeft: "auto", display: "flex" }}
				color="primary"
				disabled={isLoading}
				fullWidth
			>
				Send Invite
			</Button>
		</Box>
	);
};

export default InvitationOrg;
